import backofficeService from '../../api/backoffice'
import publicService from '../../api/public'


export default {
  /**
   * Get list of products
   * @param {*} params
   * @param {*} params.limit
   * @param {*} params.offset
   * @param {*} params.search
   * @param {*} params.local Add LocalData to products
   */
  getAll(params) {
    return backofficeService.Api().get('campaign', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getCampaignById(id) {
    return publicService.Api().get(`/public/campaign/${id}`)
      .then(response => {
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },


  async publicDonationCreate(id, data) {
    return publicService.Api().post(`public/donor/donation?key=${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  async publicDonationNoLimit(id, data) {
    return publicService.Api().post(`public/donor/donationNoLimit?key=${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  async publicDonationSponsor(id, data) {
 
    return publicService.Api().post(`public/donor/donationSponsor?key=${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getAllPayeeExpenseTotal(params) {
    return backofficeService.Api().get('campaign/totalExpense', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Get specific product
   * @param {*} id
   * @param {*} params
   * @param {*} params.local Add LocalData to product
   */
  getById(id, params = {}) {
    return backofficeService.Api().get(`campaign/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  /**
   * Create a product. Will also initiate location data
   * @param {*} data
   */
  create(data) {
    return backofficeService.Api().post('campaign', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific product
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`campaign/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete product
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`campaign/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

}